// src/core/score/dealScoreBadges.ts
// Badge-Farben je Urteil, aus der gemeinsamen Design-Palette (src/design/tokens.css /
// propora-design-kit/design/tokens.css -- App und Website nutzen dieselben Werte).
// Lime bleibt dem Haupt-Akzent (CTAs) vorbehalten, wird hier nicht verwendet. Rot/
// Terrakotta ist exklusiv "Nicht empfehlenswert" vorbehalten.
//
// Alle vier Flaeche/Text-Paare liegen bei >= 4,5:1 Kontrast (WCAG AA), rechnerisch
// geprueft: Guter Deal 10,17:1 - Solide 10,10:1 - Kritisch 6,28:1 - Nicht
// empfehlenswert 4,80:1.
//
// "Kritisch" (Amber) ist kein Token aus tokens.css -- dafuer gibt es dort keine
// passende Farbe, Wert bleibt wie vor der Design-Grundlage. "Nicht empfehlenswert"
// nutzt --pr-negative als Textfarbe (so vorgegeben), die helle Terrakotta-Flaeche
// (#F7E8E1) ist davon abgeleitet (kein Token in tokens.css dafuer), gegen mehrere
// Kandidaten geprueft und mit Dominik abgestimmt (09.10.2026).

import type { DealUrteil } from "./dealScore.js";
import { colors } from "../../design/tokens";

export type DealScoreBadge = {
  background: string;
  text: string;
};

export const DEAL_SCORE_BADGES: Record<DealUrteil, DealScoreBadge> = {
  "Guter Deal": { background: colors.forest, text: colors.white },       // --pr-forest / --pr-white
  "Solide, mit Schwächen": { background: colors.sageSoft, text: colors.ink }, // --pr-sage-soft / --pr-ink
  "Kritisch": { background: "#FDF0D5", text: "#92400E" },                 // Amber, wie bisher
  "Nicht empfehlenswert": { background: "#F7E8E1", text: colors.negative }, // abgeleitete Flaeche / --pr-negative
};
